export default {
    1: 'light-blue',
    2: 'purple',
    3: 'light-green'
}